
import {defineComponent,computed,ref,watch,onBeforeUnmount} from 'vue'
import store from '@/store'
import router from '@/router'
import api from '@/api/loginSecurity'
import {CustomerNotice,noticeDestination,notificationCenter} from '@/utils/notificationTarget'
import {createNotificationReminder} from '@/utils/notificationReminder'
import {notificationChangedEvent,publishNotificationRead,rememberNotificationFocus,clearNotificationFocus} from '@/utils/notificationEvents'
import {couponReceiptBlocking} from '@/utils/adminNoticeRuntime'

export default defineComponent({setup(){
  const identity=computed(()=>store.getters.token && store.getters.userInfo?.id && Number(store.getters.userInfo.orgId)===Number(store.getters.orgId)?[store.getters.orgId,store.getters.userInfo.id].join(':'):'')
  // 付款、登录、通知中心不额外打断；返回普通页面只检查，不能重置本次已提醒记录。
  const canPresent=computed(()=>!!identity.value && !couponReceiptBlocking.value && router.currentRoute.value.path!==notificationCenter && !/orderconfirm|upgradeLevel|buycourse|login/i.test(router.currentRoute.value.path))
  const notice=ref<CustomerNotice|null>(null),opening=ref(false),error=ref('')
  const reminder=createNotificationReminder({
    identity:()=>identity.value,enabled:()=>canPresent.value,list:()=>api.list(undefined,true),
    open:async item=>{
      const destination=noticeDestination(item)
      if(destination.startsWith(notificationCenter+'?'))rememberNotificationFocus(identity.value,item)
      const fullPath=router.resolve(destination).fullPath
      if(router.currentRoute.value.fullPath===fullPath)return true
      const failure=await router.push(destination)
      return !failure && router.currentRoute.value.fullPath===fullPath
    },
    read:id=>api.read(id),
    shouldMarkRead:item=>!noticeDestination(item).startsWith(notificationCenter+'?'),
    changed:state=>{notice.value=state.notice;opening.value=state.opening;error.value=state.error},
    readDone:id=>publishNotificationRead(identity.value,id)
  })
  const dismiss=()=>reminder.dismiss(),view=()=>reminder.view()
  const visibility=()=>{if(document.visibilityState==='visible')void reminder.foreground();else reminder.background()}
  const changed=(event:Event)=>{const detail=(event as CustomEvent).detail;if(detail?.identity===identity.value)reminder.invalidateRead(detail.id,detail.maxId)}
  watch(identity,()=>{clearNotificationFocus();void reminder.identityChanged()},{immediate:true,flush:'sync'})
  watch(canPresent,enabled=>{if(enabled)void reminder.load()})
  if(document.visibilityState==='hidden')reminder.background()
  const timer=window.setInterval(()=>{void reminder.load()},30000)
  document.addEventListener('visibilitychange',visibility)
  window.addEventListener(notificationChangedEvent,changed)
  onBeforeUnmount(()=>{reminder.dispose();window.clearInterval(timer);document.removeEventListener('visibilitychange',visibility);window.removeEventListener(notificationChangedEvent,changed)})
  return {notice,opening,error,canPresent,dismiss,view}
}})
